import React, { ReactNode } from 'react'
import { ModalProvider } from './old/modal/modal-provider/ModalProvider'
import { SnackbarProvider } from './old/snackbar/SnackbarProvider' // do not simplify, it causes cyclic import
import { ThemeProviderClean } from './ThemeProviderClean'
import { ToastProvider } from './new/components'
import { ThemeName } from './darkMode'
import { PersistentLoaderProvider } from './new/PersistentLoader'

interface Props {
  children?: ReactNode
  variation?: ThemeName
}

export const Provider = ({ children, variation }: Props) => {
  return (
    <ThemeProviderClean variation={variation}>
      <PersistentLoaderProvider>
        <SnackbarProvider>
          <ToastProvider>
            <ModalProvider>{children}</ModalProvider>
          </ToastProvider>
        </SnackbarProvider>
      </PersistentLoaderProvider>
    </ThemeProviderClean>
  )
}
